<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :classDialog="'add-docs-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm văn bản liên quan</h3>
      <el-row :gutter="24" class="flex-row flex__left">
        <el-col :span="10" class="flex-row flex__left">
          <el-radio-group v-model="docType" @change="docTypeChange">
            <el-radio size="mini" :label="docTypeVbDen">Văn bản đến</el-radio>
            <el-radio size="mini" :label="docTypeVbDi" v-if="checkedVbLienQuan()">Văn bản đi</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="14" class="flex-row">
          <i class="el-icon-search margin-right-10 clickable"></i>
          <el-input
            size="medium"
            placeholder="Nhập Trích yếu/Số kí hiệu để tìm kiếm"
            class="style-fullWidth input-border__radius__0 input-border__bottom"
            v-model="keyword"
            @keydown.enter.exact.native="search"
          />
        </el-col>
      </el-row>
      <div class="margin-bottom-10">
        <el-table
          ref="multipleTable"
          :data="docs"
          size="mini"
          stripe
          style="width: 100%"
          max-height="500"
          @selection-change="docSelectionChange"
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column label="Tên trích yếu" show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{ scope.row.quote }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Số kí hiệu" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{
                  scope.row.docCode
                }}</span>
            </template>
          </el-table-column>
          <el-table-column property="docDate" label="Ngày văn bản" width="125">
            <template slot-scope="scope">
              <div class="flex-row flex__left" @click="itemClicked(scope.row)">
                <!-- <div class="theDueDate lv1 margin-right-10"></div> -->
                <p>
                  {{
                    scope.row.docDate
                      | dateFormatter({dateFormat: "DD/MM/YYYY"})
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          type="success"
          size="mini"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >Xác nhận
        </el-button>
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="cancel"
        >Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import vbIncomingDocUserViewService from "../../../services/vbIncomingDocUserViewService";
import vbOutgoingDocUserViewService from "../../../services/vbOutgoingDocUserViewService";
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import h from "../../../services/h";

export default {
  name: "dialog-add-docs",
  props: ["attachedType", "isOpen", "modalAppendToBody", "docIds"],
  filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue")
  },
  data() {
    return {
      docTypeVbDi: null,
      docTypeVbDen: null,
      docType: null,
      keyword: null,
      docs: null,
      selectedDocs: []
    };
  },

  created() {
    this.docTypeVbDi = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI;
    this.docTypeVbDen = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;
    this.docType = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;

    this.search();
  },

  methods: {
    docTypeChange() {
      this.docs = [];
      this.selectedDocs = [];
      this.keyword = null;

      this.search();
    },

    itemClicked(item) {
      this.$refs.multipleTable.toggleRowSelection(item);
    },

    submit() {
      this.$emit("submit", {docs: this.selectedDocs, docType: this.docType});
    },

    cancel() {
      this.$emit("closeDialog");
    },

    docSelectionChange(val) {
      this.selectedDocs = val;
    },

      search() {
        if (this.docType == this.docTypeVbDen) {
          vbIncomingDocUserViewService
            .findAll(0, this.keyword, null, null, {
              sort: "updateTime,desc",
              page: 0,
              size: 100
            })
            .then(response => {
              this.docs = h.findAll(
                response.data,
                item =>
                  this.docIds.indexOf(item.vbIncomingDocUserViewKey.id) === -1
              );
            });
        } else {
          vbOutgoingDocUserViewService
            .findAll(
              0,
              this.keyword,
              null,
              null,
              {
                sort: "updateTime,desc",
                page: 0,
                size: 100
              },
              constants.OUTGOING_DOC_STATUS.DABANHANH
            )
            .then(response => {
              this.docs = h.findAll(
                response.data,
                item =>
                  this.docIds.indexOf(item.vbOutgoingDocUserViewKey.id) === -1
              );
            });
        }
      },

      checkedVbLienQuan() {
        return this.attachedType !== constants.DOC_RELATION_ATTACHED_TYPE.VB_LIEN_QUAN_LINK ;
      },
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/job/create-job/dialog-add-docs.vue